window.dd = console.log;
window.php  = {};
window.php.trim = require('locutus/php/strings/trim');
window.php.rtrim = require('locutus/php/strings/rtrim');
window.php.sprintf = require('locutus/php/strings/sprintf');
// window.php.ucfirst = require('locutus/php/strings/ucfirst')